<template>
    <b-form-select v-bind:id="id" v-bind:name="name" v-model="selectedYear" :options="yearOptions" :state="state"></b-form-select>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: null,
        },
        id: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        state: {
            type: String,
            default: null,
        },
    },
    computed: {
        selectedYear: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    data() {
        return {
            yearOptions: [],
        };
    },
    mounted() {
        // 当前年份
        const currentYear = new Date().getFullYear();
        for (let i = 1950; i < currentYear; i++) {
            this.yearOptions.push({ value: i, text: i + " 年" });
        }
    }
}
</script>